interface OrderItem {
  id: string;
  orderId: string;
  courseId: string;
  title: string;
  amount: number;
  date: string;
  status: 'paid' | 'pending' | 'closed';
}

const STATUS_TEXT = {
  paid: '已付款',
  pending: '待支付',
  closed: '已关闭'
};

const OrderHistory = ({
  orders,
  onContinuePay
}: {
  orders: OrderItem[];
  onContinuePay: (id: string) => void;
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
      {orders.length === 0 ? (
        <div className="py-16 text-center text-slate-400 text-sm">暫無訂單記錄</div>
      ) : (
        <div className="divide-y divide-slate-50">
          {orders.map((order) => (
            <div key={order.id} className="px-6 py-4 flex items-center justify-between gap-4">
              <div>
                <p className="text-sm font-semibold text-[#0A1628]">{order.title}</p>
                <p className="text-[11px] text-slate-400 mt-1 font-mono">{order.orderId}</p>
              </div>
              <div className="flex items-center gap-5">
                <div className="text-right">
                  <p className="text-sm font-bold text-[#0A1628]">${order.amount}</p>
                  <p className="text-[11px] text-slate-400 mt-1">{order.date || '待同步'}</p>
                  <p className="text-[11px] text-violet-600 mt-1">{STATUS_TEXT[order.status]}</p>
                </div>
                {order.status === 'pending' ? (
                  <button
                    onClick={() => onContinuePay(order.id)}
                    className="rounded-xl bg-emerald-600 px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-emerald-700"
                  >
                    繼續付款
                  </button>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
